import React, { useCallback } from 'react';
import { IContentFieldProps } from 'types/fields';
import ContentTextField from './ContentTextField';

interface IIdpInputTextFieldProps extends IContentFieldProps {
	lineNum?: number;
	placeholder?: string;
	spellCheck?: boolean;
}

const IdpInputTextField: React.FC<IIdpInputTextFieldProps> = ({
	name,
	displayName,
	disabled,
	value,
	onChange,
	required,
	lineNum = 1,
	error,
	placeholder = undefined,
	spellCheck = true
}) => {
	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			onChange(e.target.value);
		},
		[onChange]
	);

	return (
		<ContentTextField
			data-testid="field-default"
			key={name}
			name={name}
			label={displayName}
			disabled={disabled}
			required={required}
			multiline={lineNum > 1}
			minRows={lineNum}
			maxRows={lineNum}
			placeholder={placeholder}
			value={value || ''}
			onChange={handleChange}
			error={Boolean(error)}
			helperText={error}
			slotProps={{ htmlInput: { spellCheck } }}
		/>
	);
};

export default IdpInputTextField;
